<h2>Institutions</h2>

<mat-spinner *ngIf="updating"></mat-spinner>

<div class="button_row" *ngIf="!updating">
    <button mat-raised-button (click)="back()">Back</button>
    <button mat-raised-button color="primary" (click)="addNew()">Add New</button>
</div>

<div *ngIf="institutions?.length && !updating" class="paginator_row">
    <mat-paginator #paginator
                   [hidden]="updating"
                   [length]="institutions?.length"
                   [pageIndex]="INITIAL_PAGE_INDEX"
                   [pageSize]="INITIAL_PAGE_SIZE"
                   [pageSizeOptions]="[5, 10, 20]"
                   (page)="pageChanged($event)"></mat-paginator>
</div>
<table mat-table *ngIf="institutions?.length && !updating"
       [dataSource]="instRange">

    <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Name</th>
        <td mat-cell *matCellDef="let inst" [innerHTML]="inst.name"></td>
    </ng-container>

    <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef>Type</th>
        <td mat-cell *matCellDef="let inst">{{inst.type}}</td>
    </ng-container>

    <ng-container matColumnDef="contactEmail">
        <th mat-header-cell *matHeaderCellDef>Contact Email</th>
        <td mat-cell *matCellDef="let inst">{{inst.contactEmail}}</td>
    </ng-container>

    <ng-container matColumnDef="contactName">
        <th mat-header-cell *matHeaderCellDef>Contact Name</th>
        <td mat-cell *matCellDef="let inst">{{inst.contactName}}</td>
    </ng-container>

    <ng-container matColumnDef="promoPrefix">
        <th mat-header-cell *matHeaderCellDef>Promo prefix</th>
        <td mat-cell *matCellDef="let inst">{{inst.promoPrefix}}</td>
    </ng-container>

    <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell class="action_buttons" *matCellDef="let inst">
            <mat-icon class="link" (click)="edit(inst)" title="Edit">edit</mat-icon>
            <mat-icon class="link" (click)="orders(inst)" title="Orders">attach_money</mat-icon>
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
    <tr mat-row
        *matRowDef="let inst; columns: columnsToDisplay"></tr>

</table>

